import React, { useState, useEffect } from 'react';
import FormularioServicio from './FormularioServicio'; 
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css"; 

const GestionServicios = () => {
  const [servicios, setServicios] = useState([]);
  const [puertosMap, setPuertosMap] = useState(new Map());
  const [terminoBusqueda, setTerminoBusqueda] = useState("");
  const [terminoDebounced, setTerminoDebounced] = useState("");
  const [modo, setModo] = useState('lista'); 
  const [servicioIdActual, setServicioIdActual] = useState(null); 
  const [refreshKey, setRefreshKey] = useState(0); 

  useEffect(() => {
    const timerId = setTimeout(() => {
      setTerminoDebounced(terminoBusqueda);
    }, 500);
    return () => { clearTimeout(timerId); };
  }, [terminoBusqueda]);

  useEffect(() => {
    const fetchPuertos = async () => {
      try {
        const response = await authFetch('/api/Puerto');
        if (!response.ok) throw new Error('Error al cargar la lista de puertos');
        
        const puertosLista = await response.json(); 
        const mapa = new Map();
        for (const puerto of puertosLista) {
          mapa.set(puerto.id, puerto.nombre); 
        }
        setPuertosMap(mapa);
        
      } catch (error) {
        // Error silencioso para no interrumpir la UI si fallan los puertos
      }
    };
    
    fetchPuertos();
  }, []); 

  useEffect(() => {
    if (modo === 'lista') {
      const fetchServicios = async () => {
        try {
          const response = await authFetch('/api/Servicio');
          if (!response.ok) throw new Error('Error al conectar con el backend');
          
          const data = await response.json(); 

          const t = terminoDebounced.trim().toLowerCase();
          const filtrados = t 
            ? data.filter(s => s.servicio_nombre?.toLowerCase().includes(t))
            : data;
          
          setServicios(filtrados || []); 

        } catch (error) {
          setServicios([]); 
        }
      };
      fetchServicios();
    }
  }, [terminoDebounced, modo, refreshKey]); 

  const handleCrearServicio = () => {
    setServicioIdActual(null); 
    setModo('formulario');     
  };

  const handleEditar = (id) => {
    setServicioIdActual(id);   
    setModo('formulario');   
  };

  const handleEliminar = async (id) => {
    const servicio = servicios.find(s => s.id === id);
    const nombre = servicio?.servicio_nombre || servicio?.nombre || id;
    
    if (!window.confirm(`¿Estás seguro de que deseas eliminar el servicio "${nombre}"?`)) {
      return;
    }

    try {
      const response = await authFetch(`/api/Servicio/${id}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        alert('Servicio eliminado con éxito');
        setRefreshKey(k => k + 1); 
      } else {
        const err = await response.json();
        throw new Error(err.message || 'Error al eliminar');
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  const handleSaveSuccess = () => {
    alert(servicioIdActual ? 'Servicio actualizado con éxito' : 'Servicio creado con éxito');
    setModo('lista');
    setServicioIdActual(null);
    setRefreshKey(k => k + 1); 
  };

  const handleCloseForm = () => {
    setModo('lista');
    setServicioIdActual(null);
  };

  if (modo === 'formulario') {
    return (
      <FormularioServicio
        servicioId={servicioIdActual}
        onClose={handleCloseForm}
        onSaveSuccess={handleSaveSuccess}
      />
    );
  }

  return (
    <div className="aseg-main">
      <div className="aseg-header">
        <h1 className="aseg-title">Gestión de Servicios de Puerto</h1>
        <button className="aseg-btn" onClick={handleCrearServicio}>
          + Crear Nuevo Servicio
        </button>
      </div>

      <div className="aseg-search">
        <input
          type="text"
          placeholder="Buscar por Nombre del Servicio..."
          value={terminoBusqueda}
          onChange={(e) => setTerminoBusqueda(e.target.value)}
        />
      </div>

      <div className="aseg-card">
        <div className="aseg-table-wrapper">
          <table className="aseg-table">
            <thead>
              <tr>
                <th>Nombre del Servicio</th>
                <th>Puerto</th>
                <th>Tipo</th>
                <th>Tipo de Tráfico</th>
                <th className="col-acciones">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {servicios.length === 0 ? (
                <tr>
                  <td colSpan="5" className="aseg-empty">
                    No se encontraron servicios
                  </td>
                </tr>
              ) : (
                servicios.map((servicio) => (
                  <tr key={servicio.id}>
                    <td>{servicio.servicio_nombre}</td>
                    
                    <td>
                      {puertosMap.get(servicio.id_puerto) || servicio.id_puerto}
                    </td> 
                    
                    <td>{servicio.servicio}</td>
                    <td>{servicio.tipo_de_trafico || 'N/A'}</td>
                    <td className="td-acciones">
                      <button onClick={() => handleEditar(servicio.id)} className="aseg-link" title="Editar">
                        Editar
                      </button>
                      <button onClick={() => handleEliminar(servicio.id)} className="aseg-link aseg-link-danger" title="Eliminar">
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GestionServicios;